<template>
  <Layout>
    <PageHeader :title="$t(title)" />
    <modal v-if="showModal" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body col-md-12 mx-right">
            <div class="row" v-if="!isLoading">
              <!-- Left sidebar -->
              <div class="col-md-1">
                <img v-if="notification.picture_medium !== null" :src="load_image(notification.picture_medium)" alt=""
                  style="border-radius: 50%;" class="img-fluid" />
                <img v-else src="@/assets/images/users/default.svg" alt="" style="border-radius: 8px;"
                  class="img-fluid" />
              </div>
              <div class="col-md-9 mt-2">
                <h6 class="font-size-18">{{ notification.title }}</h6>
                <div>{{ $t('filemanager.notifications.text') }}</div>
                <div class="document p-3 mt-2" @click="preview(document, $event)">
                  <img class="mr-3" v-if="document.extension === 'pdf'" width="50" src="../../../assets/icons/pdf.png"
                    alt="">
                  <img class="mr-3" v-else-if="document.extension === 'doc' || document.extension === 'docx'" width="50"
                    src="../../../assets/icons/word.svg" alt="">
                  <img class="mr-3" v-else-if="document.extension === 'xls' || document.extension === 'xlsx'" width="50"
                    src="../../../assets/icons/excel.svg" alt="">
                  <img class="mr-3" v-else-if="document.extension === 'ppt' || document.extension === 'pptx'" width="50"
                    src="../../../assets/icons/powerpoint.svg" alt="">
                  <img class="mr-3" v-else-if="document.extension === 'mp3' || document.extension === 'wav'" width="50"
                    src="../../../assets/icons/audio.png" alt="">
                  <img class="mr-3" v-else-if="document.extension === 'mp4' || document.extension === 'mpeg'" width="50"
                    src="../../../assets/icons/video.png" alt="">
                  <img v-else width="50" src="../../../assets/icons/picture.png" alt="">
                  {{ document.name }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- end Col-9 -->
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { mapActions, mapState } from "vuex";
import appConfig from "@/app.config";

import managerHelper from "../../../components/manager/mixins/manager"
export default {
  page: {
    title: "Read notif",
    meta: [{ name: "description", content: appConfig.description }],
  },
  mixins: [managerHelper],
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "filemanager.notifications.title",
      isLoading: false,
      document: {},
      document_id: null
    };
  },
  computed: {
    ...mapState({
      notification: state => state.userAuth.notification,
      showModal: (state) => state.modal.showModal,
    }),
    selectedItem() {
      return this.$store.getters['selectedItems'][0];
    }
  },
  methods: {
    ...mapActions(['getNotifById', 'getDocumentById', 'getDocumentPath']),
    preview(document, event) {
      this.getDocumentPath(document.id).then(response => {
        let path = response.data+"/"+document.name;
        this.document.path = path;
        this.selectItem('files', path, event);
        this.selectAction(path, document.extension);
      })
    },

    load_image(picture) {
      return process.env.VUE_APP_IMAGE_URL + picture;
    },
  },
  mounted() {
  },
  updated() {
  },
  created() {
    this.getNotifById(this.$route.params.id).then(response => {
      this.getDocumentById(response.data.doc_id).then(response => {
        this.document = response.data;
        this.$store.commit(`left/setDirectoryContent`, { directories : [], files : [this.document]})
      })
      console.log("Notif : ", response);
    });

  },
};
</script>

<style>
  .document {
    border-radius: 10px; 
    background-color: #f1f5fa;
    font-size: 1em;
  }
  .document:hover {
    cursor: pointer;
    background-color: #dfe7f0;
  }
  .doc-path:hover {
    cursor: pointer;
    text-decoration: underline;
    color: rgb(41, 141, 255)
  }
</style>
